<template>
  <div id="add-patient" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 add-patient-container">
      <form @submit.prevent="addPatient" novalidate>
        <div class="row">
          <div class="col-sm-12">
            <div class="owner-info-container">
              <div class="user-profile-header">
                <h3>{{translation.profile.userProfile}}</h3>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group text-left">
                    <div :class="{ requiredField: requiredEmail }">
                      <input type="email" @change="changedForm" class="form-control"
                             name="user-registration-email" v-model="response.email" :placeholder="translation.registration.email + translation.registration.requiredSymbol">
                      <label for="user-registration-email">{{translation.registration.email + translation.registration.requiredSymbol}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group text-left">
                    <div :class="{ requiredField: requiredFirstName }">
                      <input type="text" @change="changedForm" class="form-control" name="user-firstName" v-model="response.firstName" :placeholder="translation.registration.firstName + translation.registration.requiredSymbol">
                      <label for="user-firstName">{{translation.registration.firstName + translation.registration.requiredSymbol}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group text-left">
                    <div :class="{ requiredField: requiredLastName }">
                      <input type="text" @change="changedForm" class="form-control" name="user-lastName" v-model="response.lastName" :placeholder="translation.registration.lastName + translation.registration.requiredSymbol">
                      <label for="user-lastName">{{translation.registration.lastName + translation.registration.requiredSymbol}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group text-left">
                    <div :class="{ requiredField: requiredPhoneNumber }">
                    <input type="text" class="form-control" id="phoneNumber" name="user-phoneNumber" :placeholder="translation.registration.phoneNumber + translation.registration.requiredSymbol" v-model="response.phoneNumber">
                    <label for="user-phoneNumber"><span>{{translation.registration.phoneNumber}}</span><span class="text-danger">{{translation.registration.requiredSymbol}}</span></label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p v-if="errors.length" class="text-left text-danger">
                    <b>{{translation.registration.correct}}:</b>
                    <ul class="list-group">
                      <li class="text-danger text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
                    </ul>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p v-if="addPatienSuccess" class="text-success text-left"><b>{{translation.registration.createPatientSuccess + response.firstName + ' ' + response.lastName + '!'}}</b></p>
                  <p v-if="addPatienSuccess" class="text-success text-left"><b>{{translation.registration.createPatientSendEmail}}</b></p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 terms">
                  <span class="tersm-text"><input type='checkbox' v-model='siteTerms' />{{translation.button.patientAgree}}</span>
                  <span class="terms-links tersm-text" @click="showModalGdpr">{{translation.button.terms + translation.button.and +' ' +translation.button.gdpr}}</span>
                  <span class="tersm-text">{{translation.button.patientAgreeWith}}</span>
                  <div v-if='showModalBody' class="modal text-left">
                    <div class="modal-content" >
                      <div class="modal-header text-center">
                        <span class="close-modal" @click="showModalGdpr">&times;</span>
                        <h3 class="text-center"><p class="text-center">{{translation.gdpr.header}}</p> <p class="text-center">{{translation.generalTerms.title}}</p> <p class="text-center">{{translation.gdpr.secondHeader}}</p></h3>
                      </div>
                      <div class="modal-body text-center">
                        <div class="text-center">
                          <h4>{{translation.gdpr.thirdHeader}}</h4>
                        </div>
                        <div class="">
                          <p>{{translation.gdpr.p1}}</p>
                          <p>{{translation.gdpr.p2}} <a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>.</p>
                          <p>{{translation.gdpr.p3}}</p>
                          <div class="text-center">
                            <h4>{{translation.gdpr.dh}}</h4>
                            <p>{{translation.gdpr.dc}}</p>
                            <p>{{translation.gdpr.dc1}}</p>
                            <p>{{translation.gdpr.dp}}</p>
                            <p>{{translation.gdpr.de}}</p>
                          </div>
                          <p>{{translation.gdpr.p4}}</p>
                          <div class="text-left">
                            <h4>{{translation.gdpr.h1}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.h2}}</h4>
                            <p class="font-italic">{{translation.gdpr.p5}}</p>
                          </div>
                          <h4>{{translation.gdpr.h3}}</h4>
                          <p>{{translation.gdpr.t1}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.t2}}</p>
                          <p>{{translation.gdpr.t3}}</p>
                          <h4>{{translation.gdpr.h4}}</h4>
                          <p>{{translation.gdpr.d1}}</p>
                          <p>{{translation.gdpr.d2}}</p>
                          <p>{{translation.gdpr.d3}}</p>
                          <p>{{translation.gdpr.p6}}</p>
                          <h4>{{translation.gdpr.h5}}</h4>
                          <p>{{translation.gdpr.p7}}</p>
                          <p>{{translation.gdpr.t4}}</p>
                          <p>{{translation.gdpr.t5}}</p>
                          <p>{{translation.gdpr.t6}}</p>
                          <h4>{{translation.gdpr.h6}}</h4>
                          <p>{{translation.gdpr.t7}}</p>
                          <p>{{translation.gdpr.t8}}</p>
                          <p>{{translation.gdpr.t9}}</p>
                          <p>{{translation.gdpr.p8}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p9}}</p>
                          <h4>{{translation.gdpr.h7}}</h4>
                          <p>{{translation.gdpr.t10}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>.</p>
                          <p>{{translation.gdpr.t11}}</p>
                          <p>{{translation.gdpr.t12}}</p>
                          <h4>{{translation.gdpr.h8}}</h4>
                          <p>{{translation.gdpr.p10}}</p>
                          <p>{{translation.gdpr.p11}}</p>
                          <h4>{{translation.gdpr.h9}}</h4>
                          <p>{{translation.gdpr.p12}}</p>
                          <p>{{translation.gdpr.p13}}</p>
                          <h4>{{translation.gdpr.h10}}</h4>
                          <p>{{translation.gdpr.p14}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p15}}</p>
                          <p>{{translation.gdpr.p16}}</p>
                          <h4>{{translation.gdpr.h11}}</h4>
                          <p>{{translation.gdpr.p17}}</p>
                          <h4>{{translation.gdpr.h12}}</h4>
                          <p>{{translation.gdpr.p18}}</p>
                          <h4>{{translation.gdpr.h13}}</h4>
                          <p>{{translation.gdpr.p19}}</p>
                          <h4>{{translation.gdpr.h14}}</h4>
                          <p>{{translation.gdpr.p20}}</p>
                          <h4>{{translation.gdpr.h15}}</h4>
                          <p>{{translation.gdpr.p21}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p22}}</p>
                          <h4>{{translation.gdpr.h16}}</h4>
                          <p>{{translation.gdpr.p23}}</p>
                          <p>{{translation.gdpr.t13}}</p>
                          <p>{{translation.gdpr.t14}}</p>
                          <p>{{translation.gdpr.t15}}</p>
                          <p>{{translation.gdpr.t16}}</p>
                          <p>{{translation.gdpr.t17}}</p>
                          <p>{{translation.gdpr.p24}}</p>
                          <p>{{translation.gdpr.t18}}</p>
                          <p>{{translation.gdpr.t19}}</p>
                          <p>{{translation.gdpr.t20}}</p>
                          <h4>{{translation.gdpr.h17}}</h4>
                          <p>{{translation.gdpr.p25}}</p>
                          <h4>{{translation.gdpr.h18}}</h4>
                          <p>{{translation.gdpr.p26}}</p>
                          <h4>{{translation.gdpr.h19}}</h4>
                          <p>{{translation.gdpr.p27}}</p>
                          <h4>{{translation.gdpr.h20}}</h4>
                          <p>{{translation.gdpr.p28}}</p>
                          <p>{{translation.gdpr.p29}}</p>
                          <p>{{translation.gdpr.t21}}</p>
                          <p>{{translation.gdpr.t22}}</p>
                          <p>{{translation.gdpr.t23}}</p>
                          <h4>{{translation.gdpr.h23}}</h4>
                          <p>{{translation.gdpr.p40}}</p>
                          <h4>{{translation.gdpr.h21}}</h4>
                          <p>{{translation.gdpr.p30}}</p>
                          <div class="text-center">
                            <p>{{translation.gdpr.p31}}</p>
                            <p>{{translation.gdpr.p36}}</p>
                            <p>{{translation.gdpr.p32}}</p>
                            <p>{{translation.gdpr.p33}}</p>
                          </div>
                          <p>{{translation.gdpr.p34}}</p>
                          <p>{{translation.gdpr.p35}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h1}}</h4>
                          <p><span>{{translation.generalTerms.p1}}</span><router-link :to="{name:'home', params:{ lang: lang}}">{{translation.generalTerms.link}}</router-link><span>{{translation.generalTerms.p2}}</span></p>
                          <p><span>{{translation.generalTerms.p3}}</span><router-link :to="{name:'home', params:{ lang: lang}}">{{translation.generalTerms.link}}</router-link><span>{{translation.generalTerms.p4}}</span></p>
                          <p>{{translation.generalTerms.p5}}</p>
                          <p>{{translation.generalTerms.p6}}</p>
                          <p>{{translation.generalTerms.p7}}</p>
                          <p>{{translation.generalTerms.p8}}</p>
                          <p>{{translation.generalTerms.p9}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h2}}</h4>
                          <p>{{translation.generalTerms.p10}}</p>
                          <p>{{translation.generalTerms.p11}}</p>
                          <p>{{translation.generalTerms.p12}}</p>
                          <p>{{translation.generalTerms.p13}}</p>
                          <p>{{translation.generalTerms.p14}}</p>
                          <p>{{translation.generalTerms.p15}}</p>
                          <p>{{translation.generalTerms.p16}}</p>
                          <p>{{translation.generalTerms.p17}}</p>
                          <p>{{translation.generalTerms.p18}}</p>
                          <p>{{translation.generalTerms.p19}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h3}}</h4>
                          <p>{{translation.generalTerms.p20}}</p>
                          <p>{{translation.generalTerms.p21}}</p>
                          <p>{{translation.generalTerms.p22}}</p>
                          <p>{{translation.generalTerms.p23}}</p>
                          <p>{{translation.generalTerms.p24}}</p>
                          <p>{{translation.generalTerms.p25}}</p>
                          <p>{{translation.generalTerms.p26}}</p>
                          <p>{{translation.generalTerms.p27}}</p>
                          <p>{{translation.generalTerms.p28}}</p>
                          <p>{{translation.generalTerms.p29}}</p>
                          <p>{{translation.generalTerms.p30}}</p>
                          <p>{{translation.generalTerms.p31}}</p>
                          <p>{{translation.generalTerms.p32}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h4}}</h4>
                          <p>{{translation.generalTerms.p33}}</p>
                          <p>{{translation.generalTerms.p34}}</p>
                          <p>{{translation.generalTerms.p35}}</p>
                          <p>{{translation.generalTerms.p36}}</p>
                          <p>{{translation.generalTerms.p37}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h5}}</h4>
                          <p>{{translation.generalTerms.p38}}</p>
                          <p>{{translation.generalTerms.p39}}</p>
                          <p>{{translation.generalTerms.p40}}</p>
                          <p>{{translation.generalTerms.p41}}</p>
                          <p>{{translation.generalTerms.p42}}</p>
                          <p>{{translation.generalTerms.p43}}</p>
                          <p>{{translation.generalTerms.p44}}</p>
                          <p>{{translation.generalTerms.p45}}</p>
                          <p>{{translation.generalTerms.p46}}</p>
                          <p>{{translation.generalTerms.p47}}</p>
                          <p>{{translation.generalTerms.p48}}</p>
                          <p>{{translation.generalTerms.p49}}</p>
                          <p>{{translation.generalTerms.p50}}</p>
                          <p>{{translation.generalTerms.p51}}</p>
                          <p>{{translation.generalTerms.p52}}</p>
                          <p>{{translation.generalTerms.p53}}</p>
                          <p>{{translation.generalTerms.p54}}</p>
                          <p>{{translation.generalTerms.p55}}</p>
                          <p>{{translation.generalTerms.p56}}</p>
                          <p>{{translation.generalTerms.p57}}</p>
                          <p>{{translation.generalTerms.p58}}</p>
                          <p>{{translation.generalTerms.p59}}</p>
                          <p>{{translation.generalTerms.p60}}</p>
                          <p>{{translation.generalTerms.p61}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h7}}</h4>
                          <p>{{translation.generalTerms.p69}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h8}}</h4>
                          <p>{{translation.generalTerms.p70}}</p>
                          <p>{{translation.generalTerms.p71}}</p>
                          <p>{{translation.generalTerms.p72}}</p>
                        </div>
                        <div>
                          <h4>{{translation.generalTerms.h9}}</h4>
                          <p>{{translation.generalTerms.p73}}</p>
                          <p>{{translation.generalTerms.p74}}</p>
                          <p>{{translation.generalTerms.p75}}</p>
                        </div>
                        <div>
                          <br/>
                          <p>{{translation.generalTerms.p76}}</p>
                          <br/>
                        </div>
                        <div>
                          <p><b>{{translation.generalTerms.p77}}</b></p>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button class="btn close-modal-button" @click="showModalGdpr">{{translation.button.remove}}</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 text-center">
                  <button type="submit" class="btn" :disabled='isDisabled'>{{translation.button.create}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-sm-12">
          <div class="owner-info-container">
            <div class="user-profile-header">
              <h3>{{translation.doctor.addPatient}}: {{patientCount}}</h3>
            </div>
            <div class="row filter-patiens">
              <div class="col-sm-12 tect-center filter-title">
                <h3>{{translation.doctor.filter}}</h3>
              </div>
              <div class="col-md-3 text-left">
                <div class="form-group">
                  <input type="text" class="form-control" name="firstName" v-model="patiantFilter.firstName"  :placeholder="translation.registration.firstName">
                  <label for="firstName">{{translation.registration.firstName}}</label>
                </div>
              </div>
              <div class="col-md-3 text-left">
                <div class="form-group">
                  <input type="text" class="form-control" name="lastName" v-model="patiantFilter.lastName" :placeholder="translation.registration.lastName">
                  <label for="lastName">{{translation.registration.lastName}}</label>
                </div>
              </div>
              <div class="col-md-3 text-left">
                <div class="form-group">
                  <input type="text" class="form-control" name="species" v-model="patiantFilter.petSpecies" :placeholder="translation.pets.species">
                  <label for="species">{{translation.pets.species}}</label>
                </div>
              </div>
              <div class="col-md-3 text-left">
                <div class="form-group">
                  <input type="text" class="form-control" name="name" v-model="patiantFilter.petName" :placeholder="translation.pets.name">
                  <label for="name">{{translation.pets.name}}</label>
                </div>
              </div>
              <div class="col-sm-12 text-center">
                <button @click="clearFilter"class="btn">{{translation.button.clear}}</button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 patient" v-for='patient in patients'>
                <router-link :to="{name:'doctor-add-review', params:{ passportId: patient.pet.passportId, petId: patient.pet.petId}}"
                v-show="
                patiantFilter.firstName == '' && patiantFilter.lastName == '' && patiantFilter.petSpecies == '' && patiantFilter.petName == ''
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName == '' && patiantFilter.petSpecies == '' && patiantFilter.petName == ''
                || patiantFilter.firstName == '' && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies == '' && patiantFilter.petName == ''
                || patiantFilter.firstName == '' && patiantFilter.lastName == '' && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName == ''
                || patiantFilter.firstName == '' && patiantFilter.lastName == '' && patiantFilter.petSpecies == '' && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies == '' && patiantFilter.petName == ''
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName == '' && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName == ''
                || patiantFilter.firstName == '' && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName == ''
                || patiantFilter.firstName == '' && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies == '' && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName == '' && patiantFilter.petSpecies == '' && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName == '' && patiantFilter.lastName == '' && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName == ''
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies == '' && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName.toLowerCase() == patient.owner.firstName.toLowerCase() && patiantFilter.lastName == '' && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                || patiantFilter.firstName == '' && patiantFilter.lastName.toLowerCase() == patient.owner.lastName.toLowerCase() && patiantFilter.petSpecies.toLowerCase() == patient.pet.petSpecies.toLowerCase() && patiantFilter.petName.toLowerCase() == patient.pet.petName.toLowerCase()
                "
                >
                  <div class="row text-left patient-info">
                    <div class="col-sm-3">
                      {{patient.owner.firstName}}
                    </div>
                    <div class="col-sm-3">
                      {{patient.owner.lastName}}
                    </div>
                    <div class="col-sm-3">
                      {{patient.pet.petSpecies}}
                    </div>
                    <div class="col-sm-3">
                      {{patient.pet.petName}}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      translation: null,
      loader: false,
      addPatienSuccess: false,
      users: [],
      errors: [],
      requiredEmail: false,
      requiredFirstName: false,
      requiredLastName: false,
      requiredPhoneNumber: false,
      siteTerms: false,
      showModalBody:false,
      patients: [],
      patientCount: 0,
      patiantFilter: {
        firstName: '',
        lastName: '',
        petSpecies: '',
        petName: ''
      },
      response : {
        email: null,
        firstName: null,
        lastName: null,
        langCode: null,
        phoneNumber: null
      }
    }
  },
  computed: {
  	isDisabled: function(){
      return !this.siteTerms;
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.doctor.addPatient;
    this.addPatienSuccess = false;
    var self = this;
    axios.get('get-patients')
    .then(function(response){
      self.patients = response.data.result;
      self.patientCount = response.data.result.length;
    })
    .catch(err => err)
  },
  methods: {
    changedForm: function(){
      this.chenagedInput = true;
    },
    showModalGdpr() {
      if (this.showModalBody) {
        this.showModalBody = !this.showModalBody;
      }else {
        this.showModalBody = !this.showModalBody;
      }

    },
    validate: function (e) {
      this.errors = [];
      if (!this.response.email) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.email + '" ' +
          this.translation.registration.required
        );
        this.requiredEmail = true;
      } else if (!this.validEmail(this.response.email)) {
        this.errors.push(this.translation.registration.validEmail);
        this.requiredEmail = true;
      }else {
        this.requiredEmail = false;
      }
      if (!this.response.firstName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.firstName + '" ' +
          this.translation.registration.required
        );
        this.requiredFirstName = true;
      }else {
        this.requiredFirstName = false;
      }
        if (!this.response.lastName) {
          this.errors.push(
            this.translation.registration.field + ' "' +
            this.translation.registration.lastName + '" ' +
            this.translation.registration.required
          );
          this.requiredLastName = true;
        }else {
          this.requiredLastName = false;
        }
        if (!this.response.phoneNumber) {
          this.errors.push(
            this.translation.registration.field + ' "' +
            this.translation.registration.phoneNumber + '" ' +
            this.translation.registration.required
          );
          this.requiredPhoneNumber = true;
        }else {
          this.requiredPhoneNumber = false;
        }

      if (!this.errors.length) {
        return true;
      }

      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    addPatient: function (e){
      // Object.values(

      if (this.validate(e)) {
        this.loader = true;
        if (localStorage.getItem('language')) {
          this.response.langCode = localStorage.getItem('language');
        }else {
          this.response.langCode = 'bg_BG';
        }
        var formData = this.toFormData(this.response);
        var self = this;
        axios.post('add-patiant', formData)
        .then(function(response){
          self.loader = false;
        if (response.data.success && response.data.result == null) {
          const time = new Date().getTime();
          var formData = self.toFormData({lastActive:time})
              axios.post('check-last-active',formData)
              .then(function(){})
          }
          if (response.data.success && response.data.result.serverMessage) {
            var checkError = response.data.result.serverMessage;
            if (checkError == 'emptyEmail') {
              self.errors.push(self.translation.serverError.emptyEmail);
            }else if (checkError == 'invalidEmail') {
              self.errors.push(self.translation.serverError.invalidEmail);
            }else if (checkError == 'busyEmail') {
              self.errors.push(self.translation.serverError.busyEmail);
            }else if (checkError == 'invalidFirstName') {
              self.errors.push(self.translation.serverError.invalidFirstName);
            }else if (checkError == 'firstNameLengt') {
              self.errors.push(self.translation.serverError.firstNameLengt);
            }else if (checkError == 'firstNameSymbol') {
              self.errors.push(self.translation.serverError.firstNameSymbol);
            }else if (checkError == 'invalidLastName') {
              self.errors.push(self.translation.serverError.invalidLastName);
            }else if (checkError == 'LastNameLengt') {
              self.errors.push(self.translation.serverError.LastNameLengt);
            }else if (checkError == 'LastNameSymbol') {
              self.errors.push(self.translation.serverError.LastNameSymbol);
            }else if (checkError == 'validEmail') {
              self.errors.push(self.translation.serverError.validEmail);
            }else if (checkError == 'wrongEmail') {
              self.errors.push(self.translation.serverError.wrongEmail);
            }
          }else {
            self.response = { email, firstName, lastName,langCode };
            self.addPatienSuccess = true;
          }
        })
        .catch(err => err)
      }
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    },
    clearFilter: function(){
        this.patiantFilter.firstName = '';
        this.patiantFilter.lastName = '';
        this.patiantFilter.petSpecies = '';
        this.patiantFilter.petName = '';
      }
  }
}
</script>

<style lang="css" scoped>
#add-patient .add-patient-container{
  background-image: url('../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  min-height: 100vh;
  padding-top: 9em;
  background-position: center;
  background-size: cover;
  padding-bottom: 11em;
}
#add-patient .user-profile-header{
  background: #EEEEEE;
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
  margin-top: 2em;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
  text-align: left;
}
#add-patient .filter-patiens{
  background-color: #EEEEEE;
  padding: 1em;
}
#add-patient button {
  background: #FE7154;
  padding: .5em;
  padding-left: 1em;
  margin-bottom: 1em;
  margin-top: 2em;
  padding-right: 1em;
  border-radius: 2em;
  color: #fff;
}
#add-patient .patient-info{
  padding: 1em;
}
#add-patient .patient:nth-child(2){
  background-color: #EEEEEE;
  border-bottom: 1px solid #707070;
  border-top: 1px solid #707070;
}
#add-patient h3{
  /* border-bottom: 1px solid #707070; */
  padding: 1em;
  color: #3057B0;
}
#add-patient .filter-title h3 {
  color: #FE7154;
}
#add-patient .form-group{
  position: relative;
  margin-top: 2em;
}
#add-patient .owner-info-container{
  background-color: #fff;
  min-height: 100%;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em;
}
#add-patient input[type=text],
#add-patient input[type=password],
#add-patient input[type=email]
{
 color: #707070!important;
 background: none!important;
 border: none!important;
 border-radius: 0!important;
 outline: none!important;
 border-bottom: 2px solid #707070!important;
 width: 100%;
 outline: none!important;
 box-shadow: none;
}
#add-patient label {
 display: none;
}
.terms .tersm-text{
  font-size: .8em;
}
.terms .terms-links{
  display: inline-block;
  color: #3057B0;
  text-decoration: underline;
}
.terms .terms-links:hover{
  cursor: pointer;
}
#add-patient input[type=checkbox] {
  display: inline-block!important;
  width: 2em!important;
  transform: scale(1.2)!important;
  border: none!important;
}
#add-patient .registration-button{
    background: #A8A8A8;
    padding-left: 1em;
    padding-right: 1em;
    border: none;
    outline: none;
    border-radius: 5em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  #add-patient .registration-button{
      background: #FE7154;
    }
#add-patient input[type=text]:focus,
#add-patient input[type=password]:focus,
#add-patient input[type=email]:focus
{
 border-bottom: 2px solid #3057B0!important;
 outline:0px !important;
 -webkit-appearance:none;
 box-shadow: none !important;
}
#add-patient input[type=text]:focus + label ,
#add-patient input[type=password]:focus + label,
#add-patient input[type=email]:focus + label
{
  display: block;
  position: absolute;
  bottom: 2em;
  color: #212121!important;
  font-size: 1em;
}
#add-patient input[type=text]:focus::-webkit-input-placeholder,
#add-patient input[type=password]:focus::-webkit-input-placeholder,
#add-patient input[type=email]:focus::-webkit-input-placeholder
{
 color:transparent;
}
#add-patient input[type=text]::-moz-placeholder
#add-patient input[type=password]:focus::-moz-placeholder
#add-patient input[type=email]:focus::-moz-placeholder {
 color:transparent;
}
#add-patient input[type=text]:focus::-moz-placeholder
#add-patient input[type=password]:focus::-moz-placeholder
#add-patient input[type=email]:focus::-moz-placeholder {
  color:transparent;
}
#add-patient input[type=text]:focus::-ms-input-placeholder
#add-patient input[type=password]:focus::-ms-input-placeholder
#add-patient input[type=email]:focus::-ms-input-placeholder {
 color:transparent;
}
.list-group-item{
 border: none;
 background: none;
 padding-left: 0;
 font-size: .8em;
}
#add-patient .requiredField input{
 border-bottom: 2px solid #F82727!important;
}
#add-patient .requiredField label{
 color: #F82727!important;
 opacity: 1;
}
</style>
